import { Controller } from '@hotwired/stimulus';
import collapsibleElement from '../../modules/admin/collapsibleElement';
import dateTimePickers from '../../modules/admin/dateTimePickers';
import handleDatePickerFocus from '../../modules/admin/handleDatePickerFocus';
import setCharsCounters from '../../modules/enterpriseAdmin/charactersCounter';
import fileInput from '../../modules/enterpriseAdmin/fileInput';
import imageCropper from '../../modules/enterpriseAdmin/imageCropper';
import modals from '../../modules/modals';

export default class extends Controller {
  connect () {
    this.disconnectListeners = [
      collapsibleElement(),
      handleDatePickerFocus(),
      setCharsCounters(),
      modals(),
    ];
    dateTimePickers();
    fileInput();
    imageCropper();
  }

  disconnect () {
    this.disconnectListeners.forEach(disconnectListener =>
      disconnectListener(),
    );
  }
}
